export const localStorageKeys = {
  CHECKOUT_FORM: "@cakto-checkout:checkout-form",
};
